import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const analyticsPurchaseBottomSheetDisplay = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '32',
    screen: 'game feedback',
    ref_type: 'bottom sheet',
    flow: 'raspadinha',
    content_action: 'dado carregado',
    action_id: 'bottom sheet compra',
    utm_campaign: 'purchase_incentive_retry',
  })
}

export const analyticsPurchaseBottomSheetPay = (value: string) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '32',
    screen: 'game feedback',
    ref_type: 'botão',
    flow: 'raspadinha',
    content_action: 'toque',
    action_id: `Pagar - ${value}`,
    utm_campaign: 'purchase_incentive_retry',
  })
}
